module.exports = __webpack_public_path__ + "img/parser-icons.bcf8092b.svg";